var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_2263_289668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.82975 19.434C-0.276583 17.5137 -0.276583 15.1495 0.82975 13.2292L6.65796 3.11267C7.76739 1.18695 9.82068 0.000206111 12.0431 0.000206137L23.6764 0.000206276C25.8988 0.000206302 27.9521 1.18695 29.0616 3.11267L34.8898 13.2292C35.9961 15.1495 35.9961 17.5137 34.8898 19.434L29.0616 29.5505C27.9521 31.4763 25.8988 32.663 23.6764 32.663L12.0431 32.663C9.82068 32.663 7.76739 31.4763 6.65796 29.5505L0.82975 19.434Z",
    fill: "url(#paint0_linear_2263_289668)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6085 15.2519L11.7479 3.34985L9.95311 4.38442L16.8197 16.297L9.95311 28.2095L11.7479 29.244L18.6192 17.3235L32.3955 17.3235L32.3955 15.2519L18.6085 15.2519ZM18.0553 16.3076L18.0367 16.297L18.0553 16.2863V16.3076Z",
    fill: "white",
    fillOpacity: 0.31
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85676 19.3235C1.76369 17.4786 1.76369 15.1844 2.85676 13.3395L5.38236 9.07683L7.80104 4.7609C8.85176 2.88598 10.8432 1.73526 12.9923 1.76121L17.9289 1.8208L22.8655 1.76121C25.0146 1.73526 27.006 2.88598 28.0567 4.7609L30.4754 9.07685L33.001 13.3395C34.0941 15.1844 34.0941 17.4786 33.001 19.3235L30.4754 23.5861L28.0567 27.9021C27.006 29.777 25.0146 30.9277 22.8655 30.9018L17.9289 30.8422L12.9923 30.9018C10.8432 30.9277 8.85176 29.777 7.80104 27.9021L5.38236 23.5862L2.85676 19.3235ZM4.63906 14.3955C3.93177 15.5893 3.93177 17.0737 4.63905 18.2675L7.17101 22.5409C7.17525 22.5481 7.1794 22.5553 7.18347 22.5625L9.60824 26.8893C10.2881 28.1025 11.5767 28.8471 12.9673 28.8303L17.9164 28.7706C17.9247 28.7705 17.9331 28.7705 17.9414 28.7706L22.8905 28.8303C24.2811 28.8471 25.5697 28.1025 26.2495 26.8893L28.6743 22.5625C28.6784 22.5553 28.6825 22.5481 28.6868 22.5409L31.2187 18.2675C31.926 17.0737 31.926 15.5893 31.2187 14.3955L28.6868 10.1221C28.6825 10.1149 28.6784 10.1077 28.6743 10.1005L26.2495 5.77367C25.5697 4.56049 24.2811 3.8159 22.8905 3.83269L17.9414 3.89244C17.9331 3.89254 17.9247 3.89254 17.9164 3.89244L12.9673 3.83269C11.5767 3.8159 10.2881 4.56049 9.60824 5.77367L7.18347 10.1005C7.1794 10.1077 7.17525 10.1149 7.17101 10.1221L4.63906 14.3955Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0206 21.4682C21.0945 21.6265 21.0945 21.7584 21.0206 21.864C20.9573 21.9695 20.8359 22.0223 20.6565 22.0223H19.4058C19.1419 22.0223 18.9625 21.8956 18.8675 21.6423L17.9651 19.5684H11.9174L11.015 21.6423C10.9306 21.8956 10.7511 22.0223 10.4767 22.0223H9.33683C9.1574 22.0223 9.03075 21.9695 8.95687 21.864C8.89354 21.7584 8.89882 21.6265 8.9727 21.4682L13.7222 11.3042C13.8278 11.0614 14.0125 10.9401 14.2763 10.9401H15.7328C15.9967 10.9401 16.1761 11.0614 16.2711 11.3042L21.0206 21.4682ZM12.5982 18.0327H17.2844L14.9413 12.6657L12.5982 18.0327ZM22.23 11.415C22.23 11.0984 22.3884 10.9401 22.705 10.9401H23.8132C24.1298 10.9401 24.2882 11.0984 24.2882 11.415V21.5473C24.2882 21.864 24.1298 22.0223 23.8132 22.0223H22.705C22.3884 22.0223 22.23 21.864 22.23 21.5473V11.415Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_2263_289668",
    x: -9.43589,
    y: -9.43568,
    width: 54.5913,
    height: 51.5346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.71795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2263_289668"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2263_289668",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.45168
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.725838
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2263_289668"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3392
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2263_289668",
    result: "effect3_innerShadow_2263_289668"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2263_289668",
    x1: 20.3427,
    y1: 30.0845,
    x2: 12.8933,
    y2: 4.01145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41ADC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67B5A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.732ec315c09e3999ecf89b49dc683142.svg";
export { ForwardRef as ReactComponent };